import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'shared-modal-top',
    templateUrl: './modal-top.shared.component.html',
    styleUrls: ['./modal-top.shared.component.scss']
})
export class ModalTopComponent implements OnInit {
    @Output() public onCloseClick: EventEmitter<Event> = new EventEmitter();

    constructor() { }

    ngOnInit(): void { }

    public handleCloseClick($event: Event): void {
        this.onCloseClick.emit($event);  /* Consumer <- modalView */
    }
}
